var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4922 2.90625H8.96094C5.5251 2.90625 3.63281 4.79854 3.63281 8.23438V22.7656C3.63281 26.2015 5.5251 28.0938 8.96094 28.0938H23.4922C26.928 28.0938 28.8203 26.2015 28.8203 22.7656V8.23438C28.8203 4.79854 26.928 2.90625 23.4922 2.90625ZM26.8828 22.7656C26.8828 25.1423 25.8689 26.1562 23.4922 26.1562H8.96094C6.58427 26.1562 5.57031 25.1423 5.57031 22.7656V8.23438C5.57031 5.85771 6.58427 4.84375 8.96094 4.84375H23.4922C25.8689 4.84375 26.8828 5.85771 26.8828 8.23438V22.7656ZM20.7862 12.3096L17.5957 15.5L20.7862 18.6904C21.1646 19.0688 21.1646 19.6824 20.7862 20.0609C20.5976 20.2495 20.3496 20.345 20.1016 20.345C19.8536 20.345 19.6055 20.2508 19.4169 20.0609L16.2266 16.8704L13.0362 20.0609C12.8476 20.2495 12.5996 20.345 12.3516 20.345C12.1036 20.345 11.8555 20.2508 11.6669 20.0609C11.2885 19.6824 11.2885 19.0688 11.6669 18.6904L14.8574 15.5L11.6669 12.3096C11.2885 11.9312 11.2885 11.3176 11.6669 10.9391C12.0454 10.5607 12.659 10.5607 13.0374 10.9391L16.2278 14.1296L19.4183 10.9391C19.7967 10.5607 20.4102 10.5607 20.7887 10.9391C21.1646 11.3176 21.1646 11.9325 20.7862 12.3096Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitButton);
export default __webpack_public_path__ + "static/media/exit_button.df08ecee23ea7969c1d05325656d755f.svg";
export { ForwardRef as ReactComponent };